import { ContentPayload } from '../types/ContentPayload';
import { ScriptPayload, Triggers } from '../types/sdk/Triggers';

export const formatContentPayloadToScriptPayload = (
  contentPayload: ContentPayload,
): ScriptPayload => {
  if (!contentPayload) {
    console.error(
      '[formatContentPayloadToScriptPayload] contentPayload is null',
    );
    return {
      triggers: [],
    };
  }

  const triggers: Triggers[] = [];
  contentPayload.content?.map((content) => {
    return content.triggerIds.map((triggerId) => {
      return triggerId.values.map((value) => {
        return triggers.push({
          sensor: triggerId.type,
          value,
          slideIds: content.slides.map((slide) => `${slide.id}`),
          slideGroupId: content.slides[0].slideGroupId,
          slideIndex: content.slides[0].index,
          initialState: content.initialState,
        });
      });
    });
  });

  return {
    triggers,
  };
};
